import Vue from 'vue';
import Vuex from 'vuex';
import auth from "./Modules/authStore";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isLeftNavVisible: false,
    },
    mutations: {
        TOGGLE_LEFT_NAV_VISIBILITY(state, is_visible) {
            state.isLeftNavVisible = is_visible;
        }
    },
    actions: {
        toggleLeftNavVisibility({commit}, is_visible) {
            commit('TOGGLE_LEFT_NAV_VISIBILITY', is_visible);
        },
    },
    getters: {
        getLeftNavVisibility(state) {
            return state.isLeftNavVisible;
        },
    },
    modules: {
        auth,
    }
});
